import { createPageModel } from './factories/page-models-factory';
import { createElementModel } from './factories/element-model-factory';
import { UIModelType } from './constant';
import SectionModel from './section-model';

function createUIModel(uiType): any | undefined {
    switch (uiType) {
        case UIModelType.SECTION:
            return new SectionModel();
    }
    return createPageModel(uiType) ?? createElementModel(uiType);
}

export default {
    createUIModel,
};
